<template>
  <div>
    <!-- 售后保障 -->
    <div class="guarantee">
      <div class="guarantee_box" >
        <div
          class="guarantee_item"
          v-for="(item, index) in $route.query.type == 1
            ? TianyuanArr
            : floorArr"
          :key="index"
        >
          <div class="img">
            <img :src="item.img" class="img_cover" alt="" />
          </div>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      TianyuanArr: [
       {
          img: require("../../assets/indexImg/nain.png"),
          name: "50年使用寿命",
        },
        {
          img: require("../../assets/indexImg/Tianyuan_type13.png"),
          name: "5分钟内电话响应",
        },
        {
          img: require("../../assets/indexImg/Tianyuan_type12.png"),
          name: "1小时提出解决方案",
        },
        {
          img: require("../../assets/indexImg/Tianyuan_type11.png"),
          name: "24小时上门服务",
        },
      ],
      floorArr: [
       
        {
          img: require("../../assets/indexImg/floor_type24.png"),
          name: "30分钟内服务响应",
        },
        {
          img: require("../../assets/indexImg/floor_type23.png"),
          name: "24小时内受理问题",
        },
        {
          img: require("../../assets/indexImg/floor_type22.png"),
          name: "48小时内提出解决方案",
        },
        {
          img: require("../../assets/indexImg/floor_type21.png"),
          name: "72小时内执行解决方案",
        },
      ],
    };
  },
};
</script>

<style scoped lang='scss'>
.guarantee {
  width: 1200px;
  height: 54vh;
  display: flex;
  align-items: center;
  .guarantee_box {
    width: 100%;
    // height: 250px;
    height: 25vh;
    display: flex;
    justify-content: space-between;
    // margin-top: 120px;
    // margin-top: 12vh;
    // margin-bottom: 211px;
    // margin-bottom: 21.1vh;
    margin-top: 15vh;
    margin-bottom: 15vh;
    .guarantee_item {
      width: 208px;
      height: 100%;
      .img {
        width: 100%;
        height: 210px;
      }
      .name {
        width: 100%;
        // height: 29px;
        height: 2.9vh;
        margin-top: 10px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        // line-height: 29px;
        line-height: 2.9vh;
        text-align: center;
        color: #ffffff;
      }
    }
  }
}
</style>